<template>
  <div style="min-height: 100vh; display: flex">
    <v-row align="center" justify="center" no-gutters>
      <v-card flat width="90%" max-width="400px" class="pa-4 elevation-8">
        <v-card-title>Фортуна-Логистика</v-card-title>
        <v-divider />

        <!-- УБРАН блок с v-alert для ошибок -->

        <v-form>
          <v-col cols="12 px-0">
            <v-text-field v-model="login" type="text" label="Пользователь" :placeholder="!autofilled ? ' ' : ''"
              :error-messages="loginErrors" required autocomplete="username" @input="$v.login.$touch()"
              @blur="$v.login.$touch()">
              <template v-slot:prepend>
                <v-icon>mdi-account-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12 px-0">
            <v-text-field v-model="password" label="Пароль" :placeholder="!autofilled ? ' ' : ''"
              :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'" :type="passwordVisible ? 'text' : 'password'"
              :error-messages="passwordErrors" autocomplete="password" @input="$v.password.$touch()"
              @blur="$v.password.$touch()" @click:append="passwordVisible = !passwordVisible">
              <template v-slot:prepend>
                <v-icon>mdi-lock-outline</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-card-actions class="px-0">
            <v-spacer />
            <v-btn class="px-8" color="primary" :loading="submiting" @click.prevent="okClick">
              Войти
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import router from '../router'

export default {
  data: () => ({
    login: '',
    password: '',
    passwordVisible: false,
    submiting: false,
    autofilled: false,
    from: null
    // УБРАНО поле errorMessage
  }),

  computed: {
    loginErrors() {
      const errors = []
      if (!this.$v.login.$dirty) return errors
      !this.$v.login.maxLength && errors.push(`Не более ${this.$v.login.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.login.minLength && errors.push('Слишком короткое имя пользователя')
      !this.$v.login.required && errors.push('Введите имя пользователя')
      return errors
    },

    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.maxLength &&
        errors.push(`Не более ${this.$v.password.$params.maxLength.max} символов, пожалуйста`)
      !this.$v.password.required && errors.push('Введите пароль')
      return errors
    }
  },

  watch: {
    password() {
      this.autofilled = true
    },
    login() {
      this.autofilled = true
    }
  },

  validations: {
    login: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(100)
    },
    password: {
      required,
      maxLength: maxLength(20)
    }
  },

  created() {
    const from = this.$route.query.from
    if (from) this.from = from
    this.$store.dispatch('auth/logout')
  },

  methods: {
    okClick() {
      if (this.$v.$invalid) {
        this.$v.$touch()

        if (!this.$v.login.required) {
          this.$notify('error', 'Введите имя пользователя', 5000)
          return
        } else if (!this.$v.login.minLength) {
          this.$notify('error', 'Слишком короткое имя пользователя', 5000)
          return
        } else if (!this.$v.password.required) {
          this.$notify('error', 'Введите пароль', 5000)
          return
        }
        return
      }

      this.submiting = true

      this.$store
        .dispatch('auth/login', {
          login: this.login,
          password: this.password
        })
        .then(() => {  // Добавлен параметр response
          // Успешный вход - сохраняем данные
          localStorage.setItem('login', this.login)
          localStorage.setItem('password', this.password)

          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

          if (emailRegex.test(this.login)) {
            // Для email: отправляем письмо с кодом
            this.$notify('info', `На адрес ${this.login} отправлено письмо с кодом подтверждения от services@flogistic.ru`, 10000)
            router.push('/login/code')
          } else {
            this.$store.dispatch('auth/login', {
              login: this.login,
              password: this.password
            })
              .then(response => {
                // Set the token in store
                this.$store.state.auth.token = response?.token;
                localStorage.setItem('token', this.$store.state.auth.token)

                // OR if you have a setToken action:
                // return this.$store.dispatch('auth/setToken', token);

                // Then get user data
                return this.$store.dispatch('auth/setUser');
              })
              .then(() => {
                // Redirect to carQueue
                this.$router.push('/carQueue');
              })
              .catch(_ => {
                this.$notify('error', 'Ошибка при входе в систему');
              })
              .finally(() => {
                this.submiting = false;
              });
          }
        }).catch(_ => {
          this.$notify('error', 'Ошибка при входе в систему');
        })
        .finally(() => {
          this.submiting = false;
        });
    }
  }
}
</script>
